import { render } from "./Macchine.vue?vue&type=template&id=71cb5d6e&scoped=true"
import script from "./Macchine.vue?vue&type=script&lang=js"
export * from "./Macchine.vue?vue&type=script&lang=js"

import "./Macchine.vue?vue&type=style&index=0&id=71cb5d6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71cb5d6e"]])

export default __exports__